exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".GuardianInfo-header{color:var(--text-primary);font-size:16px;font-weight:500;margin-top:16px;margin-bottom:8px}.GuardianInfo-details{margin-bottom:16px}.GuardianInfo .Checkbox{font-size:14px}.GuardianInfo-border{border:1px solid var(--border-primary);margin-top:24px}.GuardianInfo-note{color:var(--text-primary)}.GuardianInfo-modal{color:var(--text-primary);font-size:14px;line-height:1.3;padding:24px;width:350px}@media only screen and (max-width: 620px){.GuardianInfo-modal{width:240px}}", ""]);

// exports
